export default __webpack_public_path__ + "static/diverse-global-team-890b113c426d394309c93052f036047b.png";